(() => {
  const TIME_ZONE = 'America/New_York';
  const UPS_CUTOFF_MINUTES = 16 * 60;
  const COUNTDOWN_WINDOW_MINUTES = 2 * 60;

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  function easternParts() {
    return Object.fromEntries(
      formatter.formatToParts(new Date())
        .filter((part) => part.type !== 'literal')
        .map((part) => [part.type, part.value])
    );
  }

  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function ymd(year, monthIndex, day) {
    return `${year}-${pad2(monthIndex + 1)}-${pad2(day)}`;
  }

  function nthWeekdayOfMonth(year, monthIndex, weekday, nth) {
    const first = new Date(Date.UTC(year, monthIndex, 1));
    const delta = (weekday - first.getUTCDay() + 7) % 7;
    return ymd(year, monthIndex, 1 + delta + ((nth - 1) * 7));
  }

  function lastWeekdayOfMonth(year, monthIndex, weekday) {
    const last = new Date(Date.UTC(year, monthIndex + 1, 0));
    const delta = (last.getUTCDay() - weekday + 7) % 7;
    return ymd(year, monthIndex, last.getUTCDate() - delta);
  }

  function fixedHolidayDates(year, monthIndex, day) {
    const dates = new Set([ymd(year, monthIndex, day)]);
    const actual = new Date(Date.UTC(year, monthIndex, day));

    if (actual.getUTCDay() === 0) {
      const observed = new Date(Date.UTC(year, monthIndex, day + 1));
      dates.add(ymd(
        observed.getUTCFullYear(),
        observed.getUTCMonth(),
        observed.getUTCDate()
      ));
    }

    return dates;
  }

  function addAll(target, values) {
    values.forEach((value) => target.add(value));
  }

  function upsBlackoutDates(year) {
    const dates = new Set();

    addAll(dates, fixedHolidayDates(year, 0, 1));
    dates.add(nthWeekdayOfMonth(year, 0, 1, 3));
    dates.add(lastWeekdayOfMonth(year, 4, 1));
    addAll(dates, fixedHolidayDates(year, 6, 4));
    dates.add(nthWeekdayOfMonth(year, 8, 1, 1));
    dates.add(nthWeekdayOfMonth(year, 10, 4, 4));
    addAll(dates, fixedHolidayDates(year, 11, 25));

    if (year === 2026) {
      dates.add('2026-12-24');
      dates.add('2026-12-31');
    }

    return dates;
  }

  function remainingLabel(totalSeconds) {
    const totalMinutes = Math.max(0, Math.ceil(totalSeconds / 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours && minutes) return `${hours}h ${minutes}m`;
    if (hours) return `${hours}h`;
    return `${minutes}m`;
  }

  function update(element) {
    const time = easternParts();
    const year = Number(time.year);
    const dateKey = `${time.year}-${time.month}-${time.day}`;
    const businessDay =
      ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(time.weekday) &&
      !upsBlackoutDates(year).has(dateKey);

    const hour = Number(time.hour);
    const minute = Number(time.minute);
    const second = Number(time.second);
    const currentMinutes = (hour * 60) + minute;
    const beforeCutoff = businessDay && currentMinutes < UPS_CUTOFF_MINUTES;

    const headline = element.querySelector('[data-cutoff-headline]');
    const detail = element.querySelector('[data-cutoff-detail]');
    if (!headline || !detail) return;

    if (beforeCutoff) {
      const remainingSeconds =
        (UPS_CUTOFF_MINUTES * 60) - ((currentMinutes * 60) + second);
      const remainingMinutes = remainingSeconds / 60;

      element.dataset.cutoffState =
        remainingMinutes <= COUNTDOWN_WINDOW_MINUTES ? 'urgent' : 'before';

      if (remainingMinutes <= COUNTDOWN_WINDOW_MINUTES) {
        headline.textContent =
          `${remainingLabel(remainingSeconds)} left for today's UPS pickup`;
        detail.textContent =
          'Complete your order by 4 PM ET · Eligible in-stock items';
      } else {
        headline.textContent =
          "Order by 4 PM ET for today's UPS pickup";
        detail.textContent =
          'Eligible in-stock items · Monday–Friday';
      }
      return;
    }

    element.dataset.cutoffState = 'after';
    headline.textContent =
      'Get a head start on the next business-day shipment';
    detail.textContent =
      'Order now and eligible in-stock items will be queued for the next UPS pickup.';
  }

  function updateAll() {
    document.querySelectorAll('[data-gpi-shipping-cutoff]').forEach(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  setInterval(updateAll, 30000);
})();
